import { useEffect } from "react";
import "@/App.css";
import { initLenis } from "./lib/smoothScroll";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { Introduction } from "./components/Introduction";
import { Services } from "./components/Services";
import { WhoWeHelp } from "./components/WhoWeHelp";
import { WhyUs } from "./components/WhyUs";
import { HowItWorks } from "./components/HowItWorks";
import { ServiceArea } from "./components/ServiceArea";
import { About } from "./components/About";
import { RequestService } from "./components/RequestService";
import { DriverRecruitment } from "./components/DriverRecruitment";
import { FinalCTA } from "./components/FinalCTA";
import { Footer } from "./components/Footer";
import { MobileContactBar } from "./components/MobileContactBar";

function App() {
  useEffect(() => {
    const lenis = initLenis();
    return () => lenis && lenis.destroy && lenis.destroy();
  }, []);

  return (
    <div className="App bg-[#FAFAF9] font-sans text-[#2D2B3D] antialiased selection:bg-[#1AD1B9]/25">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Introduction />
        <Services />
        <WhoWeHelp />
        <WhyUs />
        <HowItWorks />
        <ServiceArea />
        <About />
        <RequestService />
        <DriverRecruitment />
        <FinalCTA />
      </main>
      <Footer />
      <MobileContactBar />
    </div>
  );
}

export default App;
